/** Tooltip and aria-label text. Drops heading marks and bold markers. */
export function noticePlainText(body: string): string {
  return body
    .replace(/\*\*/g, '')
    .replace(/^#{1,6}[ \t]*/gm, '')
    .replace(/\s+/g, ' ')
    .trim()
}
